import { createCascadeGesture } from './cascadeFactory.js';
export default createCascadeGesture('left');
